import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

interface LocaleStringsResponse {
    sys: {
        type: string;
        id: string;
    };
    fields: {
        strings: Record<string, string>;
    };
}

const fetchContentfulLocaleStrings = async (
    locale: string
): Promise<Record<string, string>> => {
    const baseUrl = process.env.REACT_APP_CONTENTFUL_BASE_URL;
    const spaceId = process.env.REACT_APP_CONTENTFUL_SPACE_ID;
    const environment =
        process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master';
    const entryId = process.env.REACT_APP_CONTENTFUL_LOCALE_ENTRY_ID;
    const accessToken = process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN;

    if (!baseUrl || !spaceId || !entryId || !accessToken) {
        throw new Error(
            'Missing Contentful configuration in environment variables.'
        );
    }

    const url = `${baseUrl}/spaces/${spaceId}/environments/${environment}/entries/${entryId}?access_token=${accessToken}&locale=${locale}`;
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error(`Error fetching locale strings: ${response.status}`);
    }

    const data: LocaleStringsResponse = await response.json();
    return data.fields.strings;
};

export const useContentfulLocaleStrings = (locale: string) => {
    return useQuery({
        queryKey: ['contentfulLocaleStrings', locale],
        queryFn: () => fetchContentfulLocaleStrings(locale),
        staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    });
};
